<loren-page-content>
    <mat-card-title>{{ "toolbar.groups" | transloco }}</mat-card-title>
  <div class="row mb-3 mt-3">
    <div class="col">
      <loren-card>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{ "operations.search_here" | transloco }}</mat-label>
          <input #search matInput />
        </mat-form-field>
        <loren-hierarchy-selector
          [showCheckboxes]="false"
          [showAssetsWithoutGroup]="true"
          [filter]="search.value">
        </loren-hierarchy-selector>
      </loren-card>
    </div>
  </div>
</loren-page-content>
